import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import classNames from 'classnames'
import type {ContextType} from 'react'
import {PureComponent} from 'react'

import {cmdOrCtrl} from '../../../../../utils/keys'
import {
  PipelinesTarget,
  PipelinesTargetContext,
} from '../../../../pages/PipelinesPages/contexts/targetContext'

import type {Props} from './BuildLogNavigation.types'
import BuildLogNavigationButton from './BuildLogNavigationButton/BuildLogNavigationButton'

import styles from './BuildLogNavigation.css'

type State = {
  scrollBarSize: number | null | undefined
  scrollBarHorizontal: boolean
  scrollBarVertical: boolean
}

class BuildLogNavigation extends PureComponent<Props, State> {
  static contextType = PipelinesTargetContext
  static getDerivedStateFromProps(nextProps: Props): null | {
    scrollBarHorizontal: boolean
    scrollBarSize: number | null | undefined
    scrollBarVertical: boolean
  } {
    if (nextProps.ready) {
      return {
        scrollBarSize: nextProps.scrollBarSize,
        scrollBarHorizontal: nextProps.scrollBarHorizontal,
        scrollBarVertical: nextProps.scrollBarVertical,
      }
    }

    return null
  }

  declare context: ContextType<typeof PipelinesTargetContext>

  state: State = {
    scrollBarSize: null,
    scrollBarHorizontal: false,
    scrollBarVertical: false,
  }

  onGoFirstClick: () => void = () => {
    const {navigateToFirstMessage, target} = this.props
    navigateToFirstMessage(target)
  }

  onGoLastClick: () => void = () => {
    const {navigateToLastMessage, target} = this.props
    navigateToLastMessage(target)
  }

  render() {
    const {showedFirstId, showedLastId, startMessageId, finishMessageId, messagesExists, ready} =
      this.props
    const {scrollBarSize, scrollBarHorizontal, scrollBarVertical} = this.state
    const startShown = startMessageId != null && showedFirstId === startMessageId
    const finishShown = finishMessageId != null && showedLastId === finishMessageId
    const groupStyle =
      scrollBarSize != null && scrollBarSize > 0
        ? {
            marginRight: scrollBarVertical ? `${scrollBarSize}px` : undefined,
            marginBottom: scrollBarHorizontal ? `${scrollBarSize}px` : undefined,
          }
        : undefined

    const isPipelineContext =
      this.context === PipelinesTarget.JOB_DETAILS_POPUP ||
      this.context === PipelinesTarget.JOB_DETAILS_SIDEBAR

    return (
      <div
        className={classNames(styles.navigation, {
          [styles.pipelineTarget]: isPipelineContext,
        })}
        style={groupStyle}
      >
        <ButtonGroup split className={styles.buttons}>
          <BuildLogNavigationButton
            disabled={!messagesExists || !ready || startShown || showedFirstId == null}
            icon={isPipelineContext ? 'chevron-up' : null}
            label="Scroll to top"
            hint={`Home or ${cmdOrCtrl}↑`}
            className={classNames(styles.button, styles.start)}
            onClick={this.onGoFirstClick}
          />
          <BuildLogNavigationButton
            disabled={!messagesExists || !ready || finishShown || showedLastId == null}
            icon={isPipelineContext ? 'chevron-down' : null}
            label="To bottom"
            hint={`End or ${cmdOrCtrl}↓`}
            className={classNames(styles.button, styles.end)}
            onClick={this.onGoLastClick}
          />
        </ButtonGroup>
      </div>
    )
  }
}

export default BuildLogNavigation
